var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "w-100 flex-box bg-secondary" }, [
    _c("div", { staticClass: "card bg_disabled" }, [
      _c("div", { staticClass: "card-header pb-4 border-0" }, [
        this.$route.query && this.$route.query.login && _vm.invitation
          ? _c("div", { staticClass: "text-muted text-center mt-0 mb-3" }, [
              _c("small", [
                _vm._v(
                  "You’ve received an invitation from\n          " +
                    _vm._s(_vm.invitation.invitedBy.firstName) +
                    "\n          " +
                    _vm._s(_vm.invitation.invitedBy.lastName) +
                    " user to collaborate on the\n          " +
                    _vm._s(_vm.invitation.project.name) +
                    " Project, please login or join up below\n          to get into it!"
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "card-body bg-white" }, [
        _c("div", { staticClass: "logo-head mx-auto" }, [_c("logo")], 1),
        _vm._m(0),
        _c(
          "form",
          { attrs: { role: "form" } },
          [
            _c("base-input", {
              staticClass: "mb-3",
              attrs: {
                alternative: "",
                "prepend-icon": "ni ni-email-83",
                placeholder: "Email",
              },
              model: {
                value: _vm.email,
                callback: function ($$v) {
                  _vm.email = $$v
                },
                expression: "email",
              },
            }),
            _vm.$v.email.$error
              ? _c("div", { staticClass: "error field" }, [
                  _vm._v("\n          Valid email is required\n        "),
                ])
              : _vm._e(),
            _c("base-input", {
              staticClass: "mb-3",
              attrs: {
                alternative: "",
                "prepend-icon": "ni ni-lock-circle-open",
                type: "password",
                placeholder: "Password",
              },
              on: {
                keypress: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.handleLogin.apply(null, arguments)
                },
              },
              model: {
                value: _vm.password,
                callback: function ($$v) {
                  _vm.password = $$v
                },
                expression: "password",
              },
            }),
            _vm.$v.password.$error
              ? _c("div", { staticClass: "error field" }, [
                  _vm._v("\n          Field is required\n        "),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c(
                  "base-button",
                  {
                    staticClass: "my-4 btn-block",
                    attrs: { type: "primary" },
                    on: { click: _vm.handleLogin },
                  },
                  [_vm._v("Sign in")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "p",
          {
            staticClass: "text-center text-muted mb-5",
            staticStyle: { "margin-top": "-15px" },
          },
          [
            _c(
              "a",
              {
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("forgotPasswordLinkClicked")
                  },
                },
              },
              [_c("small", [_vm._v("Forgot password?")])]
            ),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-success btn-block",
            staticStyle: { cursor: "pointer" },
            on: {
              click: function ($event) {
                return _vm.$emit("iAmNewClicked")
              },
            },
          },
          [_vm._v("\n        Create account\n      ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "text-muted text-center mb-5",
        staticStyle: { "margin-top": "50px" },
      },
      [
        _c("span", { staticClass: "h2 text-black lh-110 mb-2" }, [
          _vm._v("Sign in"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }